import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

// const app = initializeApp({
//   apiKey: 'AIzaSyCNeuJ4H9X6VHE_QCVeO7pFSX_ffHxXofs',
//   authDomain: 'project-bva.firebaseapp.com',
//   databaseURL: 'https://project-bva.firebaseio.com',
//   projectId: 'project-bva',
//   storageBucket: 'project-bva.appspot.com',
//   messagingSenderId: '318661371064'
// })

const app = firebase.initializeApp({
  apiKey: 'AIzaSyCYYQ4Kd8lESyw5f5HMetoDZWtE1PtqvwU',
  authDomain: 'project-ava-4acb7.firebaseapp.com',
  databaseURL: 'https://project-ava-4acb7.firebaseio.com',
  projectId: 'project-ava-4acb7',
  storageBucket: 'project-ava-4acb7.appspot.com',
  messagingSenderId: '987604944516'
})

export const firedb = app.database()
export const storage = app.storage()



// WEBPACK FOOTER //
// ./src/firebase.js